import { render, staticRenderFns } from "./LessonIntroOverlay.vue?vue&type=template&id=2ba95674&scoped=true&"
import script from "./LessonIntroOverlay.vue?vue&type=script&lang=ts&"
export * from "./LessonIntroOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./LessonIntroOverlay.vue?vue&type=style&index=0&id=2ba95674&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba95674",
  null
  
)

export default component.exports